/**
 * Class description
 *
 * Created: 2017-09-22
 * @author jonas
 */
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";

export interface BitmapTextStyleData {
    fontName: string;
    fontSize?: number;
    align?: string;
    tint?: number;
    letterSpacing?: number;
    maxWidth?: number;
}


export class TeslaTextStyles {

    public static COUNT_UP_TEXTSTYLE_BIG:BitmapTextStyleData = {
        fontName : "tesla-bm-font",
        fontSize : 85
    };

    public static COUNT_UP_TEXTSTYLE:BitmapTextStyleData = {
        fontName : "tesla-bm-font",
        fontSize : 55
    };

    public static INDIVIDUAL_AMOUNT_TEXTSTYLE: BitmapTextStyleData = {
        fontName: "tesla-bm-font",
        fontSize: 25
    }

    public static EXTRA_FS_TEXT_STYLE:BitmapTextStyleData = {
        fontName : "tesla-bm-font",
        fontSize : 105
    };

    public static FS_NUMBER_TEXT_STYLE:BitmapTextStyleData = {
        fontName : "tesla-bm-font",
        fontSize : 185
    };

    static FS_INTRO_CHARGE_WILDS:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "35px",
        fontWeight : "700",
        fill : "#ffffff",
        dropShadow : true,
        dropShadowColor : "#664d1f",
        dropShadowAngle : 1.0472,
        dropShadowDistance : 6,
        wordWrap : true,
        wordWrapWidth : 400,
        align : "center",
        padding : 0
    };


    static FS_OUTRO:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "45px",
        fontWeight : "700",
        fill : "#ffffff",
        dropShadow : true,
        dropShadowColor : "#664d1f",
        dropShadowAngle : 1.0472,
        dropShadowDistance : 6,
        wordWrap : true,
        wordWrapWidth : 400,
        align : "center",
        padding : 0
    };

    static FS_PLAYED_TEXTSTYLE:TextStyleOptions = {
        fontFamily : "Open Sans",
        fontSize : "36px",
        fontWeight : "700",
        fill : "#ffffff",
        dropShadow : true,
        dropShadowColor : "#664d1f",
        dropShadowAngle : 1.0472,
        dropShadowDistance : 6,
        wordWrap : true,
        wordWrapWidth : 400,
        align : "center",
        padding : 0
    };


}

